import type { CustomTheme } from '.'

export const customTheme: CustomTheme = {
  colors: {
    primary: {
      DEFAULT: '#164565',
      '50': '#EAF4FA',
      '100': '#C4E0F2',
      '200': '#9FCCEA',
      '300': '#79B7E2',
      '400': '#53A3DA',
      '500': '#2E8FD1',
      '600': '#2472A8',
      '700': '#1B567E',
      '800': '#123954',
      '900': '#091D2A'
    }
  },
  semanticTokens: {
    colors: {
      'chakra-body-text': { _light: 'gray.800', _dark: 'whiteAlpha.900' },
      'chakra-body-bg': { _light: 'white', _dark: 'gray.800' },
      'chakra-border-color': { _light: 'gray.50', _dark: 'whiteAlpha.300' },
      // Badge
      'badge-bg': { default: 'primary.DEFAULT' },
      // Checkbox
      'checkbox-color': { default: 'gray.800' },
      'checkbox-border': { default: 'gray.500' },
      'checkbox-border-checked': { default: 'white' },
      'checkbox-shadow-color': { default: 'green.700' },
      'checkbox-shadow-highlight-color': { default: 'green.500' },
      // Dashboard
      'dashboard-header-bg': 'linear-gradient(135deg, #113957 0%, #277291 100%)',
      // Form control
      'form-helper-text-color': { default: 'gray.800' },
      // Heading
      'heading-color': { default: 'gray.800' },
      // Input
      'input-bg': 'gray.50',
      'input-border': 'primary.600',
      'input-focused-border': 'primary.400',
      'input-color': 'gray.800',
      // Label
      'label-color': 'gray.800',
      // Menu
      'menu-item-color': 'gray.800',
      // Select
      'select-bg': 'gray.50',
      'select-border': 'gray.900',
      'select-color': 'gray.800',
      'select-icon-color': 'gray.500',
      // Text
      'text-color': 'gray.800',

      // Components
      // Steps
      'steps-container-bg': 'primary.800',
      'step-bg': 'gray.100',
      'step-number-border': 'gray.100',
      'step-number-bg': 'transparent',
      'step-number-color': 'gray.100',
      'step-number-passed-bg': 'gray.100',
      'step-number-passed-color': 'gray.800',
      'step-divider-bg': 'gray.600',
      'step-current-bg': 'primary.700',
      // Steps progress
      'step-progress-passed-bg': 'primary.800',
      // Insurance Info Form Control
      'insurance-info-label-color': 'gray.100',
      'insurance-info-label-bg': 'gray.100',
      'insurance-info-value-color': 'gray.200',
      // Insurance Value
      'insurance-value-border': 'gray.300',
      // Wizzard header
      'wizzard-header-bg': 'primary.800',
      'wizzard-header-gap-bg':
                'linear-gradient(135deg, #0e7490 0%, #5eead4 100%)',
      'wizzard-header-history-timeline-dot-bg': 'gray.300',
      'wizzard-header-history-timeline-line-bg': 'gray.700',
      'wizzard-header-history-timeline-label-color': 'gray.200',
      'wizzard-header-history-timeline-user-color': 'gray.400',
      'wizzard-header-history-timeline-description-color': 'gray.200',
      'wizzard-header-history-scrollbar-thumb-color': 'gray.800',
      'wizzard-header-history-scrollbar-track-color': 'gray.600',

      'news-timeline-info-bg': 'blue.100',
      'news-timeline-info-fg': 'blue.600',
      'news-timeline-warn-bg': 'orange.200',
      'news-timeline-warn-fg': 'orange.600',
      'news-timeline-crit-bg': 'red.100',
      'news-timeline-crit-fg': 'red.600',

      'login-bg': 'linear-gradient(135deg, #113957 0%, #277291 100%)'
    },
  },
}
